const alert = {
    namespaced: true,
    state: {
      variant: "",
      message: "",
      showAlert: false
    },
    getters: {
      variant: state => state.variant,
      message: state => state.message,
      showAlert: state => state.showAlert
    },
    mutations: {
      setSuccessvariant(state) {
        state.variant = "success";
      },
      setDangervariant(state) {
        state.variant = "warning";
      },
      setMessage(state, message) {
        state.message = message;
      },
      setShowAlert(state) {
        state.showAlert = !state.showAlert
      }, 
      
      /*showAlert(state) {
        state.showAlert = true;
      },
      hideAlert(state) {
        state.showAlert = false;
      },*/
    },
    actions: {}
  };
  
  export default alert;